import { Expose, Type } from 'class-transformer'

import { Batch } from './Batch'
import { Container } from './Container'
import { FreightShipment } from './FreightShipment'
import { Product } from './Product'
import { Sku } from './Sku'

export class FreightShipmentUnit {
  get guid() {
    return this.sku?.guid
  }

  @Type(() => FreightShipment)
  shipment?: FreightShipment

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Type(() => Batch)
  batch?: Batch

  @Type(() => Container)
  container?: Container

  @Expose({ name: 'num_units' })
  numUnits?: string

  @Expose({ name: 'retailer_labels' })
  retailerLabels?: any = []
}
